<template>
  <div class="newProduct-list">
    <!-- <div class="newProduct-top">
      <img src="../../assets/index/bg.jpg" alt="">
      <div class="newProduct-top-title">
        <div>大家都在买</div>
        <div class="title-line"></div>
      </div>
    </div> -->
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1"> -->
    <div class="item-box">
      <van-row class="list">
        <!-- <div v-for="(item,i) in newProduct" :key="i">111</div> -->
        <!-- <coupon v-for="(item,index) in newProduct" :key="index" :coupinItem="item"></coupon> -->
        <van-tabs v-model="active" @click="onClick">
          <van-tab title="综合排序"></van-tab>
          <van-tab>
            <template #title>
              <div class="sort-box">
                <div>价格排序</div>
                <div class="select-icon" :style="{backgroundImage:`url(${require('../../assets/index/'+selectImg)})`}"></div>
                <!-- <img class="select-icon" :src="require(selectImg)" /> -->

              </div>
            </template>
          </van-tab>
          <van-tab title="查看分类">
            <van-row class="type-box" gutter="20">
              <van-col @click="getCatalog(item.id)" class="type-item" v-for="(item,index) in filterCategoryList" :key="index" span="4">{{item.name}}</van-col>
            </van-row>
          </van-tab>
        </van-tabs>
        <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in goodsList" :key="index" :itemInfo=itemInfo></itemInfo>

      </van-row>
    </div>
    <!-- </van-list>
    </van-pull-refresh> -->
  </div>
</template>

<script>
import itemInfo from "@/components/itemInfo";

import { getTypeList } from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "newProductStart",
  components: {
    itemInfo
  },
  data() {
    return {
      filterCategoryList: [],
      goodsList: [],
      isLoading: true,
      loading: false,
      tabClickTime: 0,
      finished: false,
      selectImg: "select_icon.png",
      active: 0,
      data: {
        isNew: "true", //	是否新品	是	[string]	true	查看
        page: 1, //	页码	是	[string]	1	查看
        size: 10, //大小	是	[string]	100	查看
        order: "desc", //排序	是	[string]	desc倒叙 asc正序	查看
        sort: "add_time", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
        categoryId: 0
      }
    };
  },
  mounted() {
    this.getList(this.data);
  },
  methods: {
    onClick(idx, title) {
      console.log(idx, title);
      switch (idx) {
        case 0:
          this.tabClickTime = 0;
          this.selectImg = "select_icon.png";
          this.data = {
            isNew: "true", //	是否新品	是	[string]	true	查看
            page: 1, //	页码	是	[string]	1	查看
            size: 10, //大小	是	[string]	100	查看
            order: "desc", //排序	是	[string]	desc倒叙 asc正序	查看
            sort: "add_time", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
            categoryId: 0
          };
          this.getList(this.data);
          break;
        case 1:
          this.tabClickTime += 1;
          if (this.tabClickTime > 1) {
            this.tabClickTime = 0;
            this.data = {
              isNew: "true", //	是否新品	是	[string]	true	查看
              page: 1, //	页码	是	[string]	1	查看
              size: 10, //大小	是	[string]	100	查看
              order: "desc", //排序	是	[string]	desc倒叙 asc正序	查看
              sort: "retail_price", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
              categoryId: 0
            };
            this.selectImg = "select_bottom.png";
            this.getList(this.data);
          } else {
            this.data = {
              isNew: "true", //	是否新品	是	[string]	true	查看
              page: 1, //	页码	是	[string]	1	查看
              size: 10, //大小	是	[string]	100	查看
              order: "asc", //排序	是	[string]	desc倒叙 asc正序	查看
              sort: "retail_price", //	固定字段	是	[string]	add_time综合 retail_price价格	查看
              categoryId: 0
            };
            this.selectImg = "select_top.png";
            this.getList(this.data);
          }
          break;
        case 2:
          this.tabClickTime = 0;
          this.selectImg = "select_icon.png";
          break;
        default:
          break;
      }
    },
    getCatalog(id) {
      this.data.categoryId = id;
      this.getList(this.data);
    },
    onRefresh() {
      Toast("刷新成功");
      this.isLoading = false;
      this.newProduct = [];
      this.data = {
        isNew: "true",
        order: "desc",
        sort: "add_time", //add_time综合   retail_price价格
        page: 0,
        size: 10,
        categoryId: 0
      };
      this.finished = false;
      // this.onLoad();
    },
    onLoad() {
      // 异步更新数据
      const nextPaging = {
        page: this.data.page + 1,
        size: 10
      };
      this.data = nextPaging;
      this.get(this.data);
    },
    getList(data) {
      getTypeList(data).then(res => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          // this.newProduct = this.newProduct.concat(newOfRes.newProduct);
          this.goodsList = newOfRes.goodsList;
          this.filterCategoryList = newOfRes.filterCategoryList;
          // this.loading = false;
          // 数据全部加载完成
          // if (this.newProduct.length == newOfRes.count) {
          //   this.finished = true;
          // }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    navToDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.newProduct-list {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  .newProduct-top {
    height: 14rem;
    overflow: hidden;
    width: 100%;
    position: relative;
    img {
      height: auto;
      width: 100%;
    }
    .newProduct-top-title {
      position: absolute;
      top: 6rem;
      left: 50%;
      width: 100%;
      margin-left: -50%;
      div {
        color: #fff;
        font-size: 1.6rem;
      }
      .title-line {
        width: 9rem;
        line-height: 1px;
        height: 1px;
        background: #fff;
        margin: 0.2rem auto 0;
      }
    }
  }
}
.item-box {
  width: 100%;
  padding-bottom: 1rem;

  .list {
    width: 100%;
    margin: 0 auto;
    /deep/ .van-tab--active {
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #a9936b;
      letter-spacing: 0;
    }
    /deep/ .van-tabs__line {
      background-color: #a9936b;
    }
    /deep/ .van-tabs {
      position: relative;
      // margin-bottom: 1rem;
      border-bottom: 1rem solid #f4f4f4;
    }
    .type-box {
      width: 100%;
      background: #fff;
      margin: 0 !important;
      .type-item {
        border: 1px solid #eee;
        padding: 0.5rem 1rem;
        margin: 0.6rem;
      }
    }
  }
}

.sort-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .select-icon {
    width: 0.6rem;
    height: 1rem;
    margin-left: 0.5rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
.item-box .list .van-tab--active {
  width: 33% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/index/newProductStart.vue